<sc-master-detail [readOnly]="!manageCatalogPermitted" [data]="data" [selection]="[selected]" (selectionChanged)="onSelectionChanged($event)"
    (addEntry)="onAddEntry($event)" (deleteEntry)="onDeleteEntry($event)">

    <sc-padding fitHeight *ngIf="selected !== articleSearchListEntry && manageCatalogPermitted" >
        <sc-flex vertical fitHeight stretchContent>
            <sc-title>
              <sc-dictionary-label dictionaryKey="erp.ui.catalog.title"></sc-dictionary-label>
            </sc-title>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-bordered-tile>
                <sc-padding>
                    <app-catalog-masterdata [catalog]="selected" [catalogAdminComponent]="this"></app-catalog-masterdata>
                </sc-padding>
            </sc-bordered-tile>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-sub-title>
              <sc-dictionary-label dictionaryKey="erp.ui.catalog.subtitle.structure"></sc-dictionary-label>
                <sc-content-spacer grow></sc-content-spacer>
                <button mat-stroked-button (click)="addRootNode()">
                    <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                    <sc-dictionary-label dictionaryKey="erp.ui.catalog.action.add-structurenode"></sc-dictionary-label>
                </button>
            </sc-sub-title>
            <sc-content-spacer vertical [half]="true"></sc-content-spacer>
            <sc-flex-fitting-content vertical>
                <sc-bordered-tile fitHeight>
                    <sc-scroll-pane>
                        <sc-padding>
                            <app-catalog-structure [catalog]="selected" [catalogAdminComponent]="this"></app-catalog-structure>
                        </sc-padding>
                    </sc-scroll-pane>
                </sc-bordered-tile>
            </sc-flex-fitting-content>
        </sc-flex>
    </sc-padding>

    <sc-padding fitHeight *ngIf="selected === articleSearchListEntry" >
      <sc-flex vertical fitHeight stretchContent>
          <sc-title>
            <sc-dictionary-label dictionaryKey="erp.ui.catalog.subtitle.article-search"></sc-dictionary-label>
          </sc-title>
          <sc-content-spacer vertical></sc-content-spacer>

          <sc-flex-fitting-content vertical>
            <sc-bordered-tile fitHeight>
                <sc-scroll-pane>
                    <sc-padding>
                      <app-catalog-article-search></app-catalog-article-search>
                    </sc-padding>
                </sc-scroll-pane>
            </sc-bordered-tile>
        </sc-flex-fitting-content>
      </sc-flex>
    </sc-padding>

</sc-master-detail>
